<div class="mb-4" *ngIf="this.title">
  <span class="text-h1 font-head">{{ this.title }}</span>
</div>
<div>
  <span class="text-copy font-text">
    {{ "serial_number_label" | translate }}: {{ this.getSerialNumber() }}
  </span>
</div>

<div class="product-doc-container" *ngIf="!this.loading; else loadingspinner">
  <div class="row" *ngIf="this.list!.items.length > 0; else noDocsFound">
    <div
      class="filter-container col col-lg-4 mb-5"
      *ngIf="list?.items === null || list!.items.length > 0"
    >
      <lh-docs-filter
        [list]="this.list?.items!"
        (filterChanged)="onFilterChanged($event)"
      ></lh-docs-filter>
    </div>
    <div class="col col-lg-8">
      <lh-docs-list
        [list]="list"
        [rows]="filteredRows"
        (selectedRows)="onRowSelection($event)"
        (needsRefresh)="loadData()"
      ></lh-docs-list>
      <lh-docs-toolbar
        [rows]="filteredRows"
        [documentIds]="selectedIds"
      ></lh-docs-toolbar>
    </div>
  </div>
  <ng-template #noDocsFound>
    <div class="mt-4">
      <span>
        {{ "no_results_found" | translate }}
      </span>
    </div>
  </ng-template>
</div>
<ng-template #loadingspinner>
  <div
    class="relative flex flex-col items-center justify-center h-full my-[128px]"
  >
    <patternlib-spinner spin></patternlib-spinner>
  </div>
</ng-template>
